import { render, staticRenderFns } from "./timerForMock.vue?vue&type=template&id=2fb05769&"
import script from "./timerForMock.vue?vue&type=script&lang=js&"
export * from "./timerForMock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports